/* ===== HERBOLOGY PAKISTAN — MAIN JS ===== */
(function() {

  // ===== MOBILE NAV =====
  const navToggle = document.getElementById('nav-toggle');
  const siteNav = document.getElementById('site-nav');
  if (navToggle && siteNav) {
    navToggle.addEventListener('click', function() {
      const open = siteNav.classList.toggle('open');
      navToggle.setAttribute('aria-expanded', open);
    });
  }

  // ===== HEADER SCROLL EFFECT =====
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', function() {
      header.classList.toggle('scrolled', window.scrollY > 50);
    }, { passive: true });
  }

  // ===== FAQ ACCORDION =====
  document.querySelectorAll('.faq-question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const item = this.closest('.faq-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(function(el) { el.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });

  // ===== TESTIMONIALS CAROUSEL =====
  // Card widths/gaps are controlled entirely by CSS (responsive breakpoints).
  // This script only handles sliding logic, dots, autoplay, and touch swipe.
  const carouselEl = document.getElementById('testimonials-carousel');
  const track = document.getElementById('testimonials-track');
  const dotsWrap = document.getElementById('testimonials-dots');
  const prevBtn = document.getElementById('testimonials-prev');
  const nextBtn = document.getElementById('testimonials-next');

  if (track && carouselEl) {
    const cards = Array.prototype.slice.call(track.querySelectorAll('.testimonial-card'));
    let perView = 1;
    let totalSlides = 1;
    let current = 0;
    let autoplayTimer = null;
    const AUTOPLAY_MS = 6000; // calm, readable pace (was too fast before)
    const SWIPE_THRESHOLD = 40;

    function getPerView() {
      const w = window.innerWidth;
      if (w >= 1024) return 3;
      if (w >= 640) return 2;
      return 1;
    }

    // Distance (in px) to move per step = one card's full outer width (incl. margin-right)
    function getStep() {
      if (!cards[0]) return 0;
      const rect = cards[0].getBoundingClientRect();
      const style = window.getComputedStyle(cards[0]);
      const marginRight = parseFloat(style.marginRight) || 0;
      return rect.width + marginRight;
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      totalSlides = Math.max(1, cards.length - perView + 1);
      for (let i = 0; i < totalSlides; i++) {
        const d = document.createElement('button');
        d.type = 'button';
        d.className = 'carousel-dot' + (i === 0 ? ' active' : '');
        d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        d.addEventListener('click', function () { goTo(i); resetAutoplay(); });
        dotsWrap.appendChild(d);
      }
    }

    function updateDots() {
      if (!dotsWrap) return;
      const dots = dotsWrap.querySelectorAll('.carousel-dot');
      dots.forEach(function (d, i) { d.classList.toggle('active', i === current); });
    }

    function goTo(idx) {
      if (!cards.length) return;
      current = ((idx % totalSlides) + totalSlides) % totalSlides; // safe wrap both directions
      track.style.transform = 'translateX(-' + (current * getStep()) + 'px)';
      updateDots();
    }

    function next() { goTo(current + 1); }
    function prevSlide() { goTo(current - 1); }

    function resetAutoplay() {
      if (autoplayTimer) clearInterval(autoplayTimer);
      if (totalSlides <= 1) return;
      autoplayTimer = setInterval(next, AUTOPLAY_MS);
    }

    function stopAutoplay() {
      if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; }
    }

    function init() {
      perView = getPerView();
      current = 0;
      buildDots();
      track.style.transition = 'none';
      goTo(0);
      requestAnimationFrame(function () { track.style.transition = ''; });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { prevSlide(); resetAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); resetAutoplay(); });

    // Pause autoplay on hover (desktop) and while touching (mobile)
    carouselEl.addEventListener('mouseenter', stopAutoplay);
    carouselEl.addEventListener('mouseleave', resetAutoplay);

    // Touch swipe support
    let touchStartX = 0;
    let touchDeltaX = 0;
    let isDragging = false;

    track.addEventListener('touchstart', function (e) {
      isDragging = true;
      touchStartX = e.touches[0].clientX;
      stopAutoplay();
      track.style.transition = 'none';
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      if (!isDragging) return;
      touchDeltaX = e.touches[0].clientX - touchStartX;
      const base = -(current * getStep());
      track.style.transform = 'translateX(' + (base + touchDeltaX) + 'px)';
    }, { passive: true });

    track.addEventListener('touchend', function () {
      if (!isDragging) return;
      isDragging = false;
      track.style.transition = '';
      if (touchDeltaX > SWIPE_THRESHOLD) prevSlide();
      else if (touchDeltaX < -SWIPE_THRESHOLD) next();
      else goTo(current);
      touchDeltaX = 0;
      resetAutoplay();
    });

    // Debounced resize — rebuild dots/positions if breakpoint changes, else just re-snap
    let resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        const newPerView = getPerView();
        if (newPerView !== perView) {
          init();
        } else {
          track.style.transition = 'none';
          goTo(current);
          requestAnimationFrame(function () { track.style.transition = ''; });
        }
      }, 150);
    });

    init();
    resetAutoplay();
  }

  // ===== CART DRAWER =====
  const cartDrawer = document.getElementById('cart-drawer');
  const cartToggle = document.getElementById('cart-toggle');
  const cartClose = cartDrawer ? cartDrawer.querySelector('.cart-drawer__close') : null;
  const cartOverlay = cartDrawer ? cartDrawer.querySelector('.cart-drawer__overlay') : null;

  function openCart() { if (cartDrawer) cartDrawer.classList.add('open'); }
  function closeCart() { if (cartDrawer) cartDrawer.classList.remove('open'); }

  if (cartToggle) cartToggle.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // ===== ADD TO CART =====
  function updateCartCount(count) {
    const el = document.getElementById('cart-count');
    if (el) el.textContent = count;
  }

  function addToCart(variantId, quantity) {
    quantity = quantity || 1;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      return fetch('/cart.js');
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      updateCartCount(cart.item_count);
      renderCartDrawer(cart);
      openCart();
    })
    .catch(function(err) { console.error('Cart error:', err); });
  }

  function renderCartDrawer(cart) {
    const body = document.getElementById('cart-drawer-body');
    if (!body) return;
    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
      return;
    }
    let html = '<div class="cart-items">';
    cart.items.forEach(function(item) {
      html += '<div class="cart-item">';
      html += '<div class="ci-img">';
      if (item.image) html += '<img src="' + item.image + '" alt="' + item.title + '">';
      html += '</div>';
      html += '<div class="ci-info">';
      html += '<div class="ci-title">' + item.product_title + '</div>';
      if (item.variant_title && item.variant_title !== 'Default Title') html += '<div class="ci-variant">' + item.variant_title + '</div>';
      html += '<div class="ci-price">Rs. ' + (item.price / 100).toLocaleString() + ' &times; ' + item.quantity + '</div>';
      html += '</div>';
      html += '<button class="ci-remove" data-key="' + item.key + '" aria-label="Remove">&times;</button>';
      html += '</div>';
    });
    html += '</div>';
    html += '<div class="cart-subtotal"><span>Subtotal</span><span>Rs. ' + (cart.total_price / 100).toLocaleString() + '</span></div>';
    body.innerHTML = html;

    body.querySelectorAll('.ci-remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: btn.dataset.key, quantity: 0 })
        })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          updateCartCount(cart.item_count);
          renderCartDrawer(cart);
        });
      });
    });
  }

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.add-to-cart-btn');
    if (!btn) return;
    e.preventDefault();
    const variantId = btn.dataset.variantId;
    if (!variantId || btn.disabled) return;
    const sectionId = btn.dataset.sectionId;
    const qtyInput = sectionId ? document.getElementById('product-qty-' + sectionId) : document.getElementById('product-qty');
    const qty = qtyInput ? parseInt(qtyInput.value) : 1;
    const originalHTML = btn.innerHTML;
    btn.textContent = 'Adding...';
    btn.disabled = true;
    addToCart(variantId, qty);
    setTimeout(function() {
      btn.textContent = '\u2713 Added!';
      setTimeout(function() {
        btn.innerHTML = originalHTML || '&#128722; Add to Cart';
        btn.disabled = false;
      }, 1500);
    }, 600);
  });

  // ===== QTY CONTROLS =====
  document.addEventListener('click', function(e) {
    const minus = e.target.closest('.qty-minus');
    const plus = e.target.closest('.qty-plus');
    if (!minus && !plus) return;
    e.preventDefault();
    const button = minus || plus;
    const sectionId = button.dataset.sectionId;
    const input = sectionId ? document.getElementById('product-qty-' + sectionId) : document.getElementById('product-qty');
    if (!input) return;
    const min = parseInt(input.getAttribute('min') || '1', 10);
    const max = parseInt(input.getAttribute('max') || '10', 10);
    let value = parseInt(input.value || '1', 10);
    if (minus) value = Math.max(min, value - 1);
    if (plus) value = Math.min(max, value + 1);
    input.value = value;
  });

  // ===== PRODUCT TABS =====
  document.querySelectorAll('.tab-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const tab = this.dataset.tab;
      document.querySelectorAll('.tab-btn').forEach(function(b) { b.classList.remove('active'); });
      document.querySelectorAll('.tab-pane').forEach(function(p) { p.classList.remove('active'); });
      this.classList.add('active');
      const pane = document.getElementById('tab-' + tab);
      if (pane) pane.classList.add('active');
    });
  });

  // ===== PRODUCT GALLERY =====
  document.querySelectorAll('.gallery-thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      const sectionId = this.dataset.sectionId;
      const mainImg = sectionId ? document.getElementById('main-product-image-' + sectionId) : document.getElementById('main-product-image');
      if (mainImg && this.dataset.src) mainImg.src = this.dataset.src;
      const scope = sectionId ? document.querySelector('.product-page--' + sectionId) : document;
      (scope || document).querySelectorAll('.gallery-thumb').forEach(function(t) { t.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  // ===== VARIANT SELECTION =====
  document.querySelectorAll('.variant-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const sectionId = this.dataset.sectionId;
      const scope = sectionId ? document.querySelector('.product-page--' + sectionId) : document;
      (scope || document).querySelectorAll('.variant-btn').forEach(function(b) { b.classList.remove('active'); });
      this.classList.add('active');
      const addBtn = sectionId ? document.getElementById('add-to-cart-' + sectionId) : document.getElementById('add-to-cart');
      if (addBtn) addBtn.dataset.variantId = this.dataset.variantId;
      const priceEl = (scope || document).querySelector('.price-current');
      if (priceEl && this.dataset.price) priceEl.textContent = this.dataset.price;
      const compareEl = (scope || document).querySelector('.price-compare');
      if (compareEl && this.dataset.comparePrice) compareEl.textContent = this.dataset.comparePrice;
    });
  });

  // ===== CART STYLES (injected) =====
  const cartStyles = document.createElement('style');
  cartStyles.textContent = '.cart-items{display:flex;flex-direction:column;gap:14px}.cart-item{display:flex;gap:14px;align-items:flex-start;padding-bottom:14px;border-bottom:1px solid #e0d8cc}.ci-img{width:64px;height:64px;border-radius:8px;overflow:hidden;background:#e8f0e8;flex-shrink:0}.ci-img img{width:100%;height:100%;object-fit:cover}.ci-info{flex:1}.ci-title{font-size:14px;font-weight:600;color:#1a1a1a;margin-bottom:3px}.ci-variant{font-size:12px;color:#888;margin-bottom:4px}.ci-price{font-size:13px;color:#1a2e1a;font-weight:600}.ci-remove{color:#888;font-size:20px;line-height:1;padding:2px 6px;flex-shrink:0;transition:color .2s}.ci-remove:hover{color:#b91c1c}.cart-subtotal{display:flex;justify-content:space-between;font-size:16px;font-weight:700;color:#1a2e1a;margin-top:20px;padding-top:16px;border-top:2px solid #1a2e1a}.site-header.scrolled{box-shadow:0 2px 30px rgba(0,0,0,0.4)}';
  document.head.appendChild(cartStyles);

})();
